export default {
  getPjsipTransport: state => state.pjsiptransport,
}
